module.exports = __webpack_public_path__ + "line-awesome.8b1290595e57e1d49d95.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/assets/vendors/line-awesome/fonts/line-awesome.woff?v=1.1.
// module id = ../../../../../src/assets/vendors/line-awesome/fonts/line-awesome.woff?v=1.1.
// module chunks = styles